import { CreateRenderFunction, NextFrame } from "@pdfking/reactivity/preact"
import { scan } from "@pdfking/rfunc"
import { Icon } from "@pdfking/workflow/components/Icon"
import { RootMixin } from "@pdfking/workflow/mixins/RootMixin"
import make_translations from "@pdfking/workflow/utils/make_translations"
import toggle_class from "../dom/toggle_class"
import state from "../state/main"
import cx from "../utils/cx"
import persistence from "../utils/persistence"

export const Collapsable = CreateRenderFunction({
  computed: {
    is_collapsed() {
      return !this.expanded && this.needs_collapse
    },
    translations: () => make_translations("actions"),
  },
  props: {
    add: "" as string,
    content: "" as string,
    height: null as number | null,
    link: false,
    persist: null as string | null,
    remove: "" as string,
    selector: null as string | null,
  },
  data: {
    expanded: false,
    max_height: 300,
    needs_collapse: false,
    store: null as {
      get: () => Promise<boolean>
      set: (v: boolean) => void
    } | null,
  },

  init() {
    this.max_height = this.height || 300
    this.store = this.persist
      ? persistence(`collapsable-${this.persist}`)
      : null
  },

  methods: {
    toggle() {
      const expanded = !this.expanded
      this.store?.set(expanded)
      this.expanded = expanded
      if (!expanded) state().track_event("button_expand", "expand")
    },
  },
  mixins: [RootMixin],
  mounted() {
    this.store?.get().then((v: boolean) => (this.expanded = v))

    NextFrame(() => {
      this.needs_collapse =
        (this.root?.querySelector(".text-content") as HTMLElement)
          ?.clientHeight > this.max_height

      if (this.needs_collapse && this.selector)
        scan(
          (el: HTMLElement) =>
            el.addEventListener("click", (e: Event) => {
              e.preventDefault()
              e.stopPropagation()
              this.toggle()
            }),
          toggle_class(this.selector, {
            [this.add]: true,
            [this.remove]: false,
          })
        )
    })
  },
  render() {
    return (
      <div class="text-collapsable">
        <div
          class={cx("text-content", {
            "text-collapsed": this.is_collapsed && this.needs_collapse,
          })}
          style={{
            "max-height": this.is_collapsed ? `${this.max_height}px` : null,
          }}
          dangerouslySetInnerHTML={{ __html: this.content }}
        />
        {this.needs_collapse && !this.selector && (
          <div class={this.link ? "text-start pt-0" : "text-center pt-3"}>
            <a
              class={this.link ? "text-muted small" : "btn btn-outline-light"}
              href="#"
              onClick={(e: Event) => {
                e.preventDefault()
                e.stopPropagation()
                this.toggle()
              }}
            >
              {this.expanded
                ? this.translations.actions.HIDE
                : this.translations.actions.SHOW_ALL}
              <Icon name="ARROW_RIGHT" />
            </a>
          </div>
        )}
      </div>
    )
  },
})
